import React, { useEffect, useContext } from 'react';
import { RulesContext } from './RulesProvider';
import { store as mainStore } from '../../../../../../store';
import { useParams } from 'react-router-dom';
import { DataGrid } from '../../../../../../components/DataGrid/DataGrid';
import { makeStyles } from '@material-ui/core';
import ProgressiveButton from 'components/Button/ProgressiveButton';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const ListRules = () => {
  const classes = useStyles();
  const { category } = useParams();
  const {
    rules,
    inProgress,
    page,
    loadRules,
    changeRulesPage,
    selectRule,
    deleteRule,
    resetAll,
  } = useContext(RulesContext);
  const {
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const columns = [
    {
      field: 'description',
      headerName: 'نام دسترسی',
      flex: 1,
    },
    {
      field: 'delete',
      headerName: 'حذف',
      width: 100,
      renderCell: () => (
        <ProgressiveButton
          onClick={null}
          variant="text"
          color="secondary"
          size="small"
          disabled={inProgress}
        >
          حذف
        </ProgressiveButton>
      ),
    },
  ];

  const handlePageChange = ({ page }) => {
    changeRulesPage(page);
  };
  const handleSelectRule = ({ field, row: { id } }) => {
    if (field === 'delete') {
      deleteRule(id);
    } else {
      const rule = rules.docs?.find((rule) => rule._id === id);
      selectRule(rule);
    }
  };
  const handleDeleteRule = (id) => {
    deleteRule(id);
  };

  useEffect(() => {
    loadRules(category, page, itemsCountPerPage);
    return () => {
      resetAll(category, page, itemsCountPerPage);
    };
  }, [category]);

  return (
    <div style={{ height: 600 }}>
      <DataGrid
        rows={
          rules?.docs?.map((rule) => ({
            id: rule._id,
            description: rule.description,
          })) || []
        }
        columns={columns}
        pageSize={itemsCountPerPage}
        rowCount={rules?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={inProgress}
        disableMultipleSelection
        onCellClick={handleSelectRule}
        density="compact"
      />
    </div>
  );
};

export default React.memo(ListRules);
